import {
  DashboardOutlined,
  DescriptionOutlined,
  PeopleOutlined,
} from "@mui/icons-material";

export const HEADER_NAVIGATION_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    icon: <DashboardOutlined />,
    end: true,
  },
  {
    id: "interviews",
    label: "Positions",
    path: "/interviews",
    icon: <DescriptionOutlined />,
  },
  // {
  //   id: "users",
  //   label: "User Management",
  //   path: "/user-management",
  //   icon: <PeopleOutlined />,
  // },
];
